import { PureComponent } from 'react';
import ErrorImage from '../../assets/images/error.svg';
import { withRouter } from 'react-router-dom';

class ErrorBoundary extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null,
        }
    }

    async componentDidCatch(error, errorInfo = null) {
        console.log(error.message);
        if(error?.message === 'Token Expired') {
            localStorage.removeItem('user_id');
            localStorage.removeItem('token');
            window.open(`https://${window.location.hostname}/login`, '_self');
            // window.location.reload();
        } else if(error?.message?.includes('403')) {
            // do nothing
        }else {
            this.setState({
                error,
                errorInfo,
            });
        }
    }

    reload () {
        this.props.history.push('/dashboard');
        window.location.reload();
    }

    render() {
        const {error }= this.state;
        return error ? <div className="page-container full-height scrollable_y">
            <div className="panel full-height">
                <div className="panel-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="mb-0"></h3>
                    </div>                                
                </div>
                <div className="panel-body scrollable_y">
                    <div className="error-container">
                        <img src={ErrorImage} alt="404"/>
                        <div className="description">
                        <h4 className="my-4">Oops! Something's Missing..</h4>
                        <p className="mb-3 text-grey"><small>It appears that we could not find what you were looking for. 
                            The Page you requested does not exist, is not available, or is loading improperly.</small></p>
                        </div>                                
                        <button onClick={() => this.reload()} className="btn btn-primary">Back To Dashboard</button>
                        <p className="mb-3 text-grey"><small>Or try again after some time</small></p>
                    </div>                            
                </div>
            </div>
        </div>
     : this.props.children;
    }

}


export default withRouter(ErrorBoundary);